import { useThemeContext } from "@contexts/ThemeContext";
import type { Professor } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { Avatar, Text } from "react-native-paper";
import ItemStem from "./ItemStem";

const DiscussionView = ({
	professor,
	title,
}: {
	professor: Professor;
	title?: string;
}) => {
	const theme = useAppTheme();
	const { isDarkMode } = useThemeContext();

	return (
		<Box gap={16} justifyContent="center">
			{title && <Text variant="titleLarge">{title}</Text>}
			<ItemStem text={professor.questionTitle!} fontSize={14} />
			<Box alignItems="center">
				<Avatar.Image size={88} source={{ uri: professor?.avatar?.url }} />
			</Box>
			<Box
				padding={16}
				backgroundColor={
					isDarkMode ? theme.palette.yellow.dark : theme.palette.yellow.light
				}
			>
				<Text variant="titleMedium">{professor?.name}</Text>
				<ItemStem text={professor?.questionBody!} />
			</Box>
		</Box>
	);
};

export default DiscussionView;
